// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsScheduling-SchedulingControl-SchedulingTable-SchedDelToolbar-SchedDelToolbar-module__container--ccEZ4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background-color: #ffe6e7;
  border-radius: 10px;
  padding: 8px 12px;
}
.src-businessServices-services-bsScheduling-SchedulingControl-SchedulingTable-SchedDelToolbar-SchedDelToolbar-module__delInfoButton--QtOBr {
  background-color: transparent;
  border: none;
  text-decoration: underline;
  cursor: pointer;
}
.src-businessServices-services-bsScheduling-SchedulingControl-SchedulingTable-SchedDelToolbar-SchedDelToolbar-module__confirmButton--FN1qX {
  background-color: #e9033a;
  border: none;
  color: #ffffff !important;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsScheduling/SchedulingControl/SchedulingTable/SchedDelToolbar/SchedDelToolbar.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;AACF;AAEA;EACE,6BAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;AAAF;AAGA;EACE,yBAAA;EACA,YAAA;EACA,yBAAA;AADF","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  background-color: #ffe6e7;\n  border-radius: 10px;\n  padding: 8px 12px;\n}\n\n.delInfoButton {\n  background-color: transparent;\n  border: none;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.confirmButton {\n  background-color: #e9033a;\n  border: none;\n  color: #ffffff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `src-businessServices-services-bsScheduling-SchedulingControl-SchedulingTable-SchedDelToolbar-SchedDelToolbar-module__container--ccEZ4`,
	"delInfoButton": `src-businessServices-services-bsScheduling-SchedulingControl-SchedulingTable-SchedDelToolbar-SchedDelToolbar-module__delInfoButton--QtOBr`,
	"confirmButton": `src-businessServices-services-bsScheduling-SchedulingControl-SchedulingTable-SchedDelToolbar-SchedDelToolbar-module__confirmButton--FN1qX`
};
export default ___CSS_LOADER_EXPORT___;
